export enum AnnualWheelPriority {
    VeryLow = 1,
    Low = 2,
    Moderate = 3,
    High = 4,
    VeryHigh = 5,
}

export const COMPLIANCE_AREA_CONTRACT_MANAGEMENT_ID = "19fca3c0-c730-40c3-a69d-dc63f81860d5";

export enum AnnualWheelActivityFramework {
    GDPR = 1,
    NIS2 = 3,
    InformationSecurity = 6,
    AI = 7,
    ContractManagement = 8,
}

export enum AnnualWheelActivityGeneralType {
    Policy = 1,
    Procedure = 2,
    TechnicalMeasure = 3,
    OrganisationalMeasure = 4,
    LogicalMeasure = 5,
    Organization = 6,
    Obligation = 7,
    Risk = 8,
    Planning = 9,
}
